import { nanoid } from "nanoid"
import { useContext, useMemo } from "react"
import { BoundContext } from "lib/@components/binding/use-bound-context"
import { targetParentMap } from "lib/discover-property-path"

/**
 * Binds data in the context to properties passed in,
 * `target` is the most common parameter that is used by all
 * other bound components to find an object to modify
 * @type {React.FunctionComponent}
 */
export function Bound({ children, targetBoundary, ...props }) {
    const context = useContext(BoundContext)
    context.target = context.target || {}
    const id = useMemo(() => nanoid(), [])
    if (props.onChange && context.onChange) {
        const fn = props.onChange
        props.onChange = () => {
            // noinspection JSIncompatibleTypesComparison,JSVoidFunctionReturnValueUsed
            if (fn() === false) return
            context.onChange()
        }
    }
    if (props.refresh) {
        props.parentRefresh = context.refresh
    }

    if (process.env.REACT_APP_EXTRA_DEBUGGING) {
        const sourceInfo = Object.create(context.sourceInfo ?? {})
        for (const key of Object.keys(props)) {
            sourceInfo[key] = props["data-filelocation"] ?? props.filelocation ?? "unknown location"
        }
        return (
            <BoundContext.Provider value={{ ...context, ...props, id, sourceInfo }}>{children}</BoundContext.Provider>
        )
    }

    if (props.target && !targetBoundary && props.target !== context.target) {
        targetParentMap.set(props.target, context.target)
    }
    return <BoundContext.Provider value={{ ...context, ...props, id }}>{children}</BoundContext.Provider>
}
